/**
 * Calm photo frame used wherever a section needs a real image.
 * Fixed aspect ratio + object-cover, soft border, lazy by default (set `priority` for above the fold).
 * `ratio` must be a full Tailwind literal so the scanner finds it (e.g. "aspect-[4/5]").
 */
export function Photo({ photo, ratio = "aspect-[4/3]", priority = false, className = "", imgClassName = "", sizes, testId }) {
  return (
    <figure
      className={`overflow-hidden rounded-3xl border border-brand-200 bg-brand-50 ${className}`}
      data-testid={testId}
    >
      <img
        src={photo.src}
        alt={photo.alt}
        width={photo.width}
        height={photo.height}
        sizes={sizes}
        loading={priority ? "eager" : "lazy"}
        decoding="async"
        className={`block h-full w-full object-cover ${ratio} ${imgClassName}`}
      />
    </figure>
  );
}
